import { Stack, Typography } from '@mui/material';
import { ValueInput, formatters } from '@utils/formattersV2';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { ComponentProps } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { ChartTitle } from './ChartTitle';
import {
  WaterfallChartProps,
  waterfallChartOptions,
} from '@features/campaigns/subdomains/visitation/configuration/waterfallChartOptions';

type WaterfallChartWithHeaderProps = ComponentProps<typeof ChartTitle> & {
  chartProps: WaterfallChartProps;
  value: number;
  valueFormatter: (value: ValueInput) => string;
  confidenceLevel: ValueInput;
};

export const WaterfallChartWithHeader = (
  props: WaterfallChartWithHeaderProps
) => {
  return (
    <Stack direction="column" gap="1rem" alignItems="center">
      <ChartTitle title={props.title} />
      <Stack direction="row" gap="0.5rem" alignItems="center">
        <Typography fontSize="h4.fontSize" fontWeight="bold">
          {props.valueFormatter(props.value)}
        </Typography>
        <Typography color={unifiedPlatformColorPalette.lightTextPrimary}>
          ({formatters.confidenceLevel(props.confidenceLevel, props.value)}{' '}
          Confidence)
        </Typography>
      </Stack>
      <HighchartsReact
        highcharts={Highcharts}
        options={waterfallChartOptions(props.chartProps)}
        containerProps={{
          ['data-testid']: 'waterfall-chart',
          style: { width: '100%' },
        }}
      />
    </Stack>
  );
};
